const fontMap = {
  bold: 'bold',
  light: 'lighter',
  medium: 'normal',
};

export default fontMap;
